module.exports = __webpack_public_path__ + "img/vof.2ddd4931.svg";